import React, { useState, useEffect, useCallback } from "react";
import { cleanArtistName } from "../utils/formatters";

const RecordModal = ({ record, trackList, onClose }) => {
    const [currentVideo, setCurrentVideo] = useState(null);
    const artistName = cleanArtistName(record.artist);

    const handlePlayTrack = (youtubeUrl) => {
        if (youtubeUrl) {
            setCurrentVideo(youtubeUrl);
        } else {
            alert("YouTube link not available for this track.");
        }
    };

    const closeVideo = () => {
        setCurrentVideo(null);
    };

    const handleEscapeKey = useCallback(
        (event) => {
            if (event.key === "Escape") {
                if (currentVideo) {
                    closeVideo();
                } else {
                    onClose();
                }
            }
        },
        [currentVideo, onClose]
    );

    useEffect(() => {
        const previousBodyOverflow = document.body.style.overflow;
        const previousHtmlOverflow = document.documentElement.style.overflow;

        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = previousBodyOverflow;
            document.documentElement.style.overflow = previousHtmlOverflow;
        };
    }, []);

    useEffect(() => {
        document.addEventListener("keydown", handleEscapeKey);
        return () => {
            document.removeEventListener("keydown", handleEscapeKey);
        };
    }, [handleEscapeKey]);

    return (
        <div
            className="modal"
            style={{
                overflow: "hidden",
            }}
        >
            <button
                className="close"
                onClick={onClose}
                style={{
                    position: "absolute",
                    top: "16px",
                    right: "16px",
                    zIndex: 2000,
                    background: "rgba(255, 255, 255, 0.92)",
                    borderRadius: "999px",
                    width: "36px",
                    height: "36px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.18)",
                }}
            >
                &times;
            </button>

            <div
                className="modal-content"
                style={{
                    maxHeight: "calc(80vh - 40px)",
                    overflowY: "auto",
                    overflowX: "hidden",
                    paddingTop: "32px",
                    paddingRight: "36px",
                }}
            >
                <center><h2>{`${artistName} - ${record.album}`}</h2></center>
                <img src={record.cover} alt={`${artistName} - ${record.album}`} />
                <p>
                    <strong>Labels:</strong> {record.labels || "N/A"}
                </p>

                <h3>Tracks:</h3>
                {trackList.length > 0 ? (
                    <ul>
                        {trackList.map((track, index) => (
                            <li key={index}>
                                <button
                                    className="play-button"
                                    onClick={() => handlePlayTrack(track.youtubeUrl)}
                                >
                                    <span role="img" aria-label="play">▶️</span>
                                </button>
                                <span className="track-position">
                                    <strong>{track.position}. </strong>
                                </span>
                                <span className="track-title">{track.title}</span>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>No track listing available.</p>
                )}
            </div>

            {currentVideo && (
                <div className="video-popup">
                    <div className="video-content">
                        <button className="close-video" onClick={closeVideo}>
                            &times;
                        </button>
                        <iframe
                            width="560"
                            height="315"
                            src={currentVideo.replace("watch?v=", "embed/")}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RecordModal;
